// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".trainee-notification__switch .v-input--switch__track{color:#ff4759!important}.trainee-notification__switch.v-input--is-label-active .v-input--switch__track{color:#00be4c!important}.trainee-notification__switch.v-input--is-label-active label{color:#000!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
